import React from 'react';
import ClockCircleBack from '../../../../assets/icons/ClockCircleBack';
import './resubmission-tag.css';

interface ResubmissionTagProps {
  className?: string;
}

function ResubmissionTag({ className }: ResubmissionTagProps) {
  return (
    <div className={`resubmission-tag ${className}`}>
      <ClockCircleBack width={16} height={16} color="var(--text-yellow)" />
      <span className="resubmission-tag-text">Resubmission</span>
    </div>
  );
}

export default ResubmissionTag;
